/** @description 一秒 */
export const ONE_SECOND = 1000
